<template>
  <div class="rich-text" v-html="this.terms"></div>
</template>

<script>
export default {
  name: "Privacy",

  computed: {
    config() {
      return this.$store.getters["config/config"] || {};
    },

    terms() {
      return (this.config && this.config.terms) || "";
    },
  },
};
</script>
